import { render, staticRenderFns } from "./BenchmarkingPopup.vue?vue&type=template&id=57079b06&scoped=true&"
import script from "./BenchmarkingPopup.vue?vue&type=script&lang=js&"
export * from "./BenchmarkingPopup.vue?vue&type=script&lang=js&"
import style0 from "./BenchmarkingPopup.vue?vue&type=style&index=0&id=57079b06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57079b06",
  null
  
)

export default component.exports